const getFileBlockContent = ({ data } = {}) => {
  if (!data) {
    return '';
  }

  const { type, name } = data;

  const mimeTypeMap = {
    image: '📷 Image',
    audio: '🎵 Audio',
    video: '🎥 Video',
  };
  const mainMimeType = type.split('/')[0];
  const textForType = mimeTypeMap[mainMimeType];

  return textForType || `📁 ${name}`;
};

const getBlockLinkContent = ({ url } = {}) => (url ? `🔗 ${url}` : '');

const getBlockContent = ({ entities }) => ({
  type,
  text,
  entity,
  children,
} = {}) => {
  switch (type) {
    case 'blockLink':
      return [getBlockLinkContent(entities[entity])];
    case 'fileBlock':
      return [getFileBlockContent(entities[entity])];
    default:
      break;
  }

  if (children && children.length) {
    return children.map(getBlockContent({ entities }));
  }

  // If there is no text (it is a new line), add a space to seperate the content
  return [text || ' '];
};

module.exports = getBlockContent;
